export const styles = {
  root: {
    flexWrap: 'nowrap',
  },
  snackbarContainer: {
    zIndex: '999999999', // snackbar messages should be the outer most layer
  },
};
